import { createIcon } from '@chakra-ui/react'

export const BoltIcon = createIcon({
  displayName: 'BoltIcon',
  viewBox: '0 0 24 25',
  path: (
    <path d='M19.875 8.82h-5.163l4.643-5.867a.188.188 0 0 0-.148-.305H10.22a.186.186 0 0 0-.162.094L3.985 13.23a.187.187 0 0 0 .162.282h4.087l-2.095 8.381c-.045.183.175.312.311.18L20.004 9.141a.186.186 0 0 0-.129-.321Zm-11.01 8.746 1.413-5.648h-3.69l4.445-7.673h5.264l-4.883 6.17h4.946l-7.495 7.151Z' fill='currentColor' />
  ),
})
